import React from 'react';

import {
  Breakpoints,
  TextAppearance,
  TextColor,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextWeight,
} from '@vw-marketing/us-components';

import { StyledRegistrationHeader } from '../styles/header-styles';
import { useMyVwContext } from '../../../shared/hooks/use-my-vw-context';
import { applyTextTransformations } from '../../../shared/utils/applyTextTransformations';
import { useFeatureServices } from '../../../shared/hooks/use-feature-services';

interface HeaderProps {
  currentStep: number;
}

export const Header = ({ currentStep }: HeaderProps) => {
  const { translationHandler } = useMyVwContext();
  const { 'locale-service': localeService } = useFeatureServices();
  const isCanada = localeService?.countryCode === 'CA';
  const getTranslationKey = () => {
  if (!isCanada) {
    return currentStep === 1
      ? 'registration.complete.information.label'
      : 'registration.create.pin.label';
  }

  switch (currentStep) {
    case 1:
      return 'registration.complete.information.label';
    case 2:
      return 'registration.termsofservice.label';
    case 3:
      return 'registration.privacypolicy.label';
    case 4:
      return 'registration.marketingconsent.label';
    case 5:
      return 'registration.create.pin.label';
    default:
      return '';
  }
};

  return (
    <StyledRegistrationHeader>
      <TextCustom
        appearance={TextAppearance.headline200}
        style={{
          [Breakpoints.default]: {
            fontSize: TextSize.TextSize16,
            color: TextColor.primary,
            fontWeight: TextWeight.light,
            lineHeight: TextLineHeight.TextLineHeight20,
          },
          [Breakpoints.b560]: {
            fontSize: TextSize.TextSize20,
            lineHeight: TextLineHeight.TextLineHeight24,
          },
          [Breakpoints.b1280]: {
            fontSize: TextSize.TextSize24,
            lineHeight: TextLineHeight.TextLineHeight28,
          },
        }}
      >
        {translationHandler('registration.steps.label').replace(
          '{x}',
          String(currentStep),
        )}
      </TextCustom>
      <TextCustom
        appearance={TextAppearance.headline200}
        style={{
          [Breakpoints.default]: {
            fontSize: TextSize.TextSize24,
            color: TextColor.primary,
            fontWeight: TextWeight.bold,
            lineHeight: TextLineHeight.TextLineHeight28,
          },
          [Breakpoints.b560]: {
            fontSize: TextSize.TextSize28,
            lineHeight: TextLineHeight.TextLineHeight32,
          },
          [Breakpoints.b1280]: {
            fontSize: TextSize.TextSize32,
            lineHeight: TextLineHeight.TextLineHeight36,
          },
        }}
      >
        {applyTextTransformations(
          translationHandler(getTranslationKey()),
          ['PIN']
        )}
      </TextCustom>
    </StyledRegistrationHeader>
  );
};
